var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { VariableSizeList } from 'react-window';
var LISTBOX_PADDING = 8; // px
var OuterElementContext = React.createContext({});
// eslint-disable-next-line react/display-name
var OuterElementType = React.forwardRef(function (props, ref) {
    var outerProps = React.useContext(OuterElementContext);
    return React.createElement("div", __assign({ ref: ref }, props, outerProps));
});
var useResetCache = function (data) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
};
// eslint-disable-next-line @typescript-eslint/space-before-function-paren
var VirtualizedListBox = forwardRef(function ListBoxBase(props, ref) {
    var children = props.children, rest = __rest(props, ["children"]);
    var innerRef = useRef(null);
    useImperativeHandle(ref, function () { return innerRef.current; });
    var itemData = [];
    children.forEach(function (item) {
        itemData.push(item);
        itemData.push.apply(itemData, __spreadArray([], __read((item.children || [])), false));
    });
    var renderRow = function (_a) {
        var index = _a.index, style = _a.style;
        return (React.createElement("div", { key: index, style: style }, itemData[index]));
    };
    var itemCount = itemData.length;
    var getChildSize = function (child) {
        var _a, _b, _c, _d, _e;
        var height = ((_a = child.props) === null || _a === void 0 ? void 0 : _a.id) && ((_c = document.getElementById((_b = child.props) === null || _b === void 0 ? void 0 : _b.id)) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height)
            ? (_e = document.getElementById((_d = child.props) === null || _d === void 0 ? void 0 : _d.id)) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().height
            : 600;
        return height !== null && height !== void 0 ? height : 60;
    };
    var getHeight = function () {
        return itemData.map(getChildSize).reduce(function (a, b) { return a + b; }, 0);
    };
    var gridRef = useResetCache(itemCount);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "variable-parent-div", ref: ref },
            React.createElement(OuterElementContext.Provider, { value: rest },
                React.createElement(VariableSizeList, { itemData: itemData, height: getHeight() + 2 * LISTBOX_PADDING, ref: gridRef, outerElementType: OuterElementType, innerElementType: "ul", innerRef: innerRef, itemSize: function (index) { return getChildSize(itemData[index]); }, width: '100%', overscanCount: 5, itemCount: itemCount }, renderRow)))));
});
export default VirtualizedListBox;
//# sourceMappingURL=VirtualizedListBox.js.map